import CircularProgress from '@material-ui/core/CircularProgress';
import Button from './Button'
import useServerWait from 'Shared/hooks/useServerWait'

export default ({ className, onClick, children, disabled, message = null, saveButton = false, ...rest }) => {
  const act = useAct()
  const saving = useSel(s => s.local.saving)
  const [me, setMe] = useState(false)

  const setSaving = (val) => {
    act.local.upsert({ saving: val })
    setMe(val)
  }

  const { doAction, succeeded } = useServerWait({ onClick, saveButton, setSaving, isSaving: saving })

  return <>
    <Button extraClass={className} onClick={doAction} type='button' disabled={disabled || (me && saving) || succeeded} {...rest}>
      {succeeded ? '✓ Saved' : <>{children} { me && saving && <CircularProgress size={20} /> }</>}
    </Button>
    { me && saving && message && <div><p className='no-margin-bottom error'>{message}</p></div> }
  </>
}
